import type { ImageTypes } from "~enums/imageTypes";
import type { Image } from "~types/image";

export const findImageByType = (images: Image[] | undefined, imageType: ImageTypes): string | undefined =>
  images ? images.find((image) => image.imageType === imageType)?.url : undefined;
